export default __webpack_public_path__ + "static/media/kitchen4-afterA-768w.f49f0d9b.avif";